module.exports = __webpack_public_path__ + "img/Review.8e05f603.svg";